import { useMemo } from 'react';
import { useAdminListUsersQuery, useMeQuery } from '@shared/api';

/** «Саитбаталова Дина» → «Саитбаталова Д.», «Селюк Сергей Александрович» → «Селюк С. А.». */
export function shortName(full: string): string {
  const [last, ...rest] = full.trim().split(/\s+/);
  if (!last) return full;
  return [last, ...rest.map((part) => `${part.charAt(0)}.`)].join(' ');
}

/**
 * Имя человека по его id для колонок «Ответственный». Своего справочника сотрудников у
 * КСП нет: имена берём из списка пользователей, если смотрит администратор, и всегда
 * знаем самого смотрящего. Не нашли — «назначен» (id в подсказке), а не код на экране.
 */
export function usePeopleNames(): (id: string | null | undefined) => {
  text: string;
  title?: string;
} {
  const { data: me } = useMeQuery();
  const isAdmin = Boolean(me?.roles?.includes('admin'));
  const { data } = useAdminListUsersQuery({ limit: 200 }, { skip: !isAdmin });
  return useMemo(() => {
    const names = new Map<string, string>();
    for (const user of data?.items ?? []) names.set(user.id, user.full_name);
    if (me?.user) names.set(me.user.id, me.user.full_name);
    return (id) => {
      if (!id) return { text: '—' };
      const full = names.get(id);
      return full ? { text: shortName(full), title: full } : { text: 'назначен', title: id };
    };
  }, [data, me]);
}
